import { Box, Grid, Skeleton } from "@mui/material";
import { type FunctionComponent } from "react";

export const CardGridSkeleton: FunctionComponent = ({ ...restProps }) => {
    return (
        <Box {...restProps} mb={5}>
            <Grid
                container
                columns={{
                    lg: 12,
                    md: 12,
                    sm: 8,
                    xl: 12,
                    xs: 4,
                }}
                spacing={4}
            >
                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>

                <Grid item xs={4} sm={8} md={6} lg={4} xl={4}>
                    <Skeleton height={130} />
                </Grid>
            </Grid>
        </Box>
    );
};
